export enum ExternalTransDataSource {
  CUSTODY = 'CUSTODY',
  TRADING = 'TRADING',
}
